import React from "react"
import PropTypes from "prop-types"
import AsyncSelect from 'react-select/async';

class SelectCompany extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      account: props.account,
      companies: props.companies,
      default_companies: props.default_companies,
      element_id: props.element_id,
      multiple: props.multiple,
      isLoading: true,
    };
  }

  componentDidMount() {
  }

  renderSelectCompany() {
    let debounceTimer;
    const account = this.state.account;
    const companies = this.state.companies;
    const default_companies = this.state.default_companies;
    const element_id = this.state.element_id;
    const multiple = this.state.multiple;

    const handleInputChange = value => {
    };

    const handleChange = value => {
      this.setState({
        companies: value,
      });
      if (multiple) {
        let result = value.map((tag) => tag.id);
        document.getElementById(element_id).value = JSON.stringify(result);
      } else {
        document.getElementById(element_id).value = value ? value.id : null;
      }
    };

    const loadOptions = (value) => {
      return fetch(`/accounts/${account.id}/companies/select?search=${value}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
          }
        }
      )
      .then(response => response.json());
    };

    const promiseOptions = (value) =>
      new Promise((resolve) => {
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(() => {
          resolve(loadOptions(value));
        }, 1000);
      });

    const handleFocus = () => {
      if (!companies && (!default_companies || default_companies.length === 0)) {
        loadOptions("").then((options) => {
          this.setState({ default_companies: options });
        });
      }
    };

    const customOption = (company) => {
      return (
        <div>
          <div className="d-flex align-items-center">
            <div className="mr-1">
              {company["title"]}
            </div>
            {company["badge"] && <div className="ml-auto small">
              {company["badge"]}
            </div>}
          </div>
          {company["description"] && <div className="small select-description">
            {company["description"]}
          </div>}
        </div>
      );
    }

    return (
      <AsyncSelect
        cacheOptions
        defaultOptions={default_companies}
        isMulti={multiple}
        placeholder={this.props.placeholder || "Select a company..."}
        value={companies}
        getOptionLabel={c => customOption(c)}
        getOptionValue={c => c.id}
        loadOptions={promiseOptions}
        onInputChange={handleInputChange}
        onChange={handleChange}
        onFocus={handleFocus}
        isClearable
        styles={{
          singleValue: (base) => ({ ...base, width: '96%' }),
          valueContainer: (base) => ({ ...base, minHeight: '44px'}),
        }}
      />
    );
  }

  render () {
    return (
      <div>
        {this.renderSelectCompany()}
      </div>
    );
  }
}

SelectCompany.propTypes = {
  account: PropTypes.object,
  companies: PropTypes.object,
  default_companies: PropTypes.array,
  element_id: PropTypes.string,
  multiple: PropTypes.bool,
  placeholder: PropTypes.string,
};

export default SelectCompany;
